import React, { useState,useEffect } from 'react';
import { TextField, Button, Grid } from '@mui/material';
import { useAccesos } from '../contexts/AccesosContext';

function GestionDescuentos({ descuento, onDescuentoGuardado }) {
  const { tienePermiso } = useAccesos();
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;
  const [descripcionTarjeta, setDescripcionTarjeta] = useState(descuento?.descripcion_tarjeta || '');
  const [porcentajeDescuento, setPorcentajeDescuento] = useState(descuento?.porcentaje_descuento || '');
  const [imagenDescuento, setImagenDescuento] = useState(null);
  const [imagenFondo, setImagenFondo] = useState(null);
  const [imagenSello, setImagenSello] = useState(null);

  // Estados para guardar las rutas de las imágenes seleccionadas
  const [rutaImagenDescuento, setRutaImagenDescuento] = useState('');
  const [rutaImagenFondo, setRutaImagenFondo] = useState('');
  const [rutaImagenSello, setRutaImagenSello] = useState('');

  // Estados para guardar la vista previa de las imágenes
  const [previewImagenDescuento, setPreviewImagenDescuento] = useState(null);
  const [previewImagenFondo, setPreviewImagenFondo] = useState(null);
  const [previewImagenSello, setPreviewImagenSello] = useState(null);


   // useEffect para cargar los datos en los campos al editar
   useEffect(() => {
    if (descuento) {
      setDescripcionTarjeta(descuento.descripcionTarjeta || '');
      setPorcentajeDescuento(descuento.porcentajeDescuento || '');
      setRutaImagenDescuento(descuento.imagenDescuento || '');
      setRutaImagenFondo(descuento.imagenFondo || '');
      setRutaImagenSello(descuento.imagenSello || '');
      setPreviewImagenDescuento(descuento.imagenDescuento || null);
      setPreviewImagenFondo(descuento.imagenFondo || null);
      setPreviewImagenSello(descuento.imagenSello || null);
    }
  }, [descuento]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('descripcionTarjeta', descripcionTarjeta);
    formData.append('porcentajeDescuento', porcentajeDescuento);
    if (imagenDescuento) formData.append('imagenDescuento', imagenDescuento);
    if (imagenFondo) formData.append('imagenFondo', imagenFondo);
    if (imagenSello) formData.append('imagenSello', imagenSello);

    try {
      const response = await fetch(`${server}/MgTarjetasDescuentoes${descuento ? '/' + descuento.id : ''}`, {
        method: descuento ? 'PUT' : 'POST',
        body: formData,
      });

      if (response.ok) {
        alert(descuento ? 'Descuento actualizado con éxito' : 'Descuento creado con éxito');
        if (onDescuentoGuardado) {
          onDescuentoGuardado();
        }
      } else {
        alert(`Error al ${descuento ? 'actualizar' : 'crear'} el descuento`);
      }
    } catch (error) {
      console.error('Error al guardar el descuento:', error);
      alert('Error al guardar el descuento');
    }
  };

  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB

const handleFileChange = (e, setImage, setRuta, setPreview) => {
  const file = e.target.files[0];

  if (file && file.size > MAX_FILE_SIZE) {
    alert('El archivo es demasiado grande. El tamaño máximo permitido es de 2 MB.');
    return;
  }

  setImage(file);
  setRuta(file ? e.target.value : '');
  setPreview(file ? URL.createObjectURL(file) : null); // Actualiza la vista previa
};

  // const handleFileChange = (e, setImage, setRuta, setPreview) => {
  //   const file = e.target.files[0];
  //   setImage(file);
  //   setRuta(file ? e.target.value : '');
  //   setPreview(file ? URL.createObjectURL(file) : null); // Actualiza la vista previa
  // };

  return (
    <div className="row">
      <div className="col-md-7 col-sm-4 offset-md-2">
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Descripción de la Tarjeta"
                value={descripcionTarjeta}
                onChange={(e) => setDescripcionTarjeta(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Porcentaje de Descuento"
                type="number"
                value={porcentajeDescuento}
                onChange={(e) => setPorcentajeDescuento(e.target.value)}
                required
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Button variant="contained" component="label">
                Seleccionar Imagen de Descuento
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, setImagenDescuento, setRutaImagenDescuento, setPreviewImagenDescuento)}
                />
              </Button>
              <TextField
                fullWidth
                label="Imagen de Descuento"
                value={rutaImagenDescuento}
                InputProps={{
                  readOnly: true,
                }}
                margin="normal"
              />
              {previewImagenDescuento && (
                <img src={previewImagenDescuento} alt="Vista previa de Descuento" style={{ width: '100%', maxHeight: '200px', marginTop: '10px' }} />
              )}
            </Grid>

            <Grid item xs={12} md={6}>
              <Button variant="contained" component="label">
                Seleccionar Imagen de Fondo
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, setImagenFondo, setRutaImagenFondo, setPreviewImagenFondo)}
                />
              </Button>
              <TextField
                fullWidth
                label="Imagen de Fondo"
                value={rutaImagenFondo}
                InputProps={{
                  readOnly: true,
                }}
                margin="normal"
              />
              {previewImagenFondo && (
                <img src={previewImagenFondo} alt="Vista previa de Fondo" style={{ width: '100%', maxHeight: '200px', marginTop: '10px' }} />
              )}
            </Grid>

            <Grid item xs={12} md={6}>
              <Button variant="contained" component="label">
                Seleccionar Imagen de Sello
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, setImagenSello, setRutaImagenSello, setPreviewImagenSello)}
                />
              </Button>
              <TextField
                fullWidth
                label="Imagen de Sello"
                value={rutaImagenSello}
                InputProps={{
                  readOnly: true,
                }}
                margin="normal"
              />
              {previewImagenSello && (
                <img src={previewImagenSello} alt="Vista previa de Sello" style={{ width: '100%', maxHeight: '200px', marginTop: '10px' }} />
              )}
            </Grid>

            <Grid item xs={12}>
              <Button type="submit" variant="contained" color="primary" disabled={!tienePermiso('Crear Descuento Análisis')}>
                {descuento ? 'Actualizar' : 'Crear'} Descuento
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </div>
  );
}

export default GestionDescuentos;
